import { render, staticRenderFns } from "./SpacingConfigurationSection.vue?vue&type=template&id=98079fec&scoped=true"
import script from "./SpacingConfigurationSection.vue?vue&type=script&lang=js"
export * from "./SpacingConfigurationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98079fec",
  null
  
)

export default component.exports